export const globalController = new AbortController();
export const globalAbortSignal = globalController.signal;

/**
 * Rejection handler for fire-and-forget waits on {@link globalAbortSignal}.
 *
 * `pWaitFor(..., {signal: globalAbortSignal})` rejects with the abort reason
 * when the app tears down (logout aborts the global controller). A chain that
 * only has `.then(...)` turns that into an *unhandled* rejection, which surfaces
 * on `window.onunhandledrejection` and in error reporting — noise that looks
 * like a crash but is just teardown. Waits that are still pending at logout are
 * the common case: several of these poll indefinitely with no timeout.
 *
 * Swallows the rejection only when the global abort actually fired; anything
 * else (e.g. a pWaitFor timeout) is still reported, so real failures are not
 * hidden.
 */
export function ignoreGlobalAbort(err: unknown): void {
    if (globalAbortSignal.aborted) return;
    console.debug('Wait rejected before the global abort fired:', err);
}

export function resetController() {
    globalController.abort();
    // Note: You can't reuse an aborted controller, so this is mainly for cleanup
}